module.exports = __webpack_public_path__ + "report.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/report.png
// module id = 447
// module chunks = 0